"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  font-family: ", ";\n  ", ";\n\n  padding: ", ";\n"])), function (p) {
  return p.theme.colorEmptyScreenBackground || "white";
}, function (p) {
  return p.theme.fontFamilyDefault;
}, function (props) {
  return props.hasBorderTop && "border-top: 2px solid ".concat(props.theme.colorBorder);
}, function (p) {
  return p.padding || "6rem 2rem";
});

var StyledTitle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 1.25rem;\n  margin-bottom: 0.75rem;\n  text-align: center;\n  color: ", ";\n"])), function (p) {
  return p.colorText || p.theme.colorText;
});

var StyledSubtitle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  font-weight: ", ";\n  color: ", ";\n  text-align: center;\n"])), function (p) {
  return p.theme.fontWeightSemibold;
}, function (props) {
  return props.colorLabel || props.theme.colorLabel;
});

var StyledIcon = (0, _styledComponents.default)(_.MatIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  font-size: 3rem;\n  color: ", ";\n"])), function (props) {
  return props.colorText || props.theme.colorLabel;
});

var EmptyScreen = function EmptyScreen(_ref) {
  var hasBorderTop = _ref.hasBorderTop,
      emptyIcon = _ref.emptyIcon,
      emptyTitle = _ref.emptyTitle,
      emptySubtitle = _ref.emptySubtitle,
      padding = _ref.padding,
      colorText = _ref.colorText,
      colorLabel = _ref.colorLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    hasBorderTop: hasBorderTop,
    padding: padding,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
      colorText: colorText,
      children: emptyIcon || "cancel_presentation"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      colorText: colorText,
      children: emptyTitle || "No Active Match"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubtitle, {
      colorLabel: colorLabel,
      children: emptySubtitle || "Next match soon"
    })]
  });
};

var _default = EmptyScreen;
exports.default = _default;